var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStyle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "35px",
    viewBox: "0 0 24 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic/ic_style") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic/ic_style",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,0 C21.7614237,0 24,2.23857625 24,5 L24,5 L24,30 C24,32.7614237 21.7614237,35 19,35 L19,35 L5,35 C2.23857625,35 0,32.7614237 0,30 L0,30 L0,5 C0,2.23857625 2.23857625,0 5,0 L5,0 Z M22,20.209 L3.1041953,32.3251842 C3.62093939,32.7470104 4.28092526,33 5,33 L5,33 L11.572,33 L22,26.398 L22,20.209 Z M22,27.582 L13.442,33 L19,33 C20.5976809,33 21.9036609,31.75108 21.9949073,30.1762728 L22,30 L22,27.582 Z M22,12.841 L2,25.655 L2,30 C2,30.5725648 2.16039981,31.1076663 2.43871587,31.5628208 L22,19.021 L22,12.841 Z M22,5.38 L2,17.976 L2,24.467 L22,11.654 L22,5.38 Z M19,2 L15.842,2 L2,10.606 L2,16.794 L21.9074761,4.25777185 C21.5911096,3.01473967 20.4985703,2.08170837 19.1762728,2.00509269 L19,2 Z M13.948,2 L5,2 C3.34314575,2 2,3.34314575 2,5 L2,5 L2,9.429 L13.948,2 Z",
    id: "Combined-Shape",
    fill: "#626469",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStyle);
export default __webpack_public_path__ + "static/media/ic_style.ca35ec91c7eca5da0dc803e0b4eced91.svg";
export { ForwardRef as ReactComponent };